import { FormStateType } from "../../../../types";
import { SHIPMENT_DETAILS_CONSTANTS } from "../../../constants";

export const formFieldsState: FormStateType = {
  [SHIPMENT_DETAILS_CONSTANTS.CARRIER_DETAILS]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [SHIPMENT_DETAILS_CONSTANTS.CARRIER_ID]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [SHIPMENT_DETAILS_CONSTANTS.CARRIER_NAME]: {
    value: "",
    errors: [],
    hidden: true,
  },
  [SHIPMENT_DETAILS_CONSTANTS.STANDARD_CARRIER_ALPHA_CODE]: {
    value: "",
    errors: [],
    hidden: true,
  },
  [SHIPMENT_DETAILS_CONSTANTS.CARRIER_EMAIL_ADDRESS]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [SHIPMENT_DETAILS_CONSTANTS.CARRIER_TYPE]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [SHIPMENT_DETAILS_CONSTANTS.TRANSPORTATION_MODE]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [SHIPMENT_DETAILS_CONSTANTS.TRAILER_TYPE]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [SHIPMENT_DETAILS_CONSTANTS.CMR_RESERVED]: {
    value: "No Information",
    errors: [],
    hidden: false,
  },
  [SHIPMENT_DETAILS_CONSTANTS.PNC_TIMELINE_MET]: {
    value: "No Information",
    errors: [],
    hidden: false,
  },
  [SHIPMENT_DETAILS_CONSTANTS.VRID_LOAD_ID]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [SHIPMENT_DETAILS_CONSTANTS.AMAZON_ORDER_NUMBER]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [SHIPMENT_DETAILS_CONSTANTS.MODE_OF_TRANSPORT_DETAILS]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [SHIPMENT_DETAILS_CONSTANTS.MODE_OF_TRANSPORT]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [SHIPMENT_DETAILS_CONSTANTS.FLIGHT_NUMBER]: {
    value: "",
    errors: [],
    hidden: true,
  },
  [SHIPMENT_DETAILS_CONSTANTS.VESSEL_NAME]: {
    value: "",
    errors: [],
    hidden: true,
  },
  [SHIPMENT_DETAILS_CONSTANTS.CONTAINER_NUMBER]: {
    value: "",
    errors: [],
    hidden: true,
  },
  [SHIPMENT_DETAILS_CONSTANTS.SHIPMENT_TYPE]: {
    value: "",
    errors: [],
    hidden: true,
  },
  [SHIPMENT_DETAILS_CONSTANTS.MODE_OF_TRANSPORT_OTHER_DESCRIPTION]: {
    value: "",
    errors: [],
    hidden: true,
  },
  [SHIPMENT_DETAILS_CONSTANTS.BILL_OF_LADING_NUMBER]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [SHIPMENT_DETAILS_CONSTANTS.BILL_OF_LADING_DETAILS]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [SHIPMENT_DETAILS_CONSTANTS.BILL_OF_LADING_DATE]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [SHIPMENT_DETAILS_CONSTANTS.ORIGINATION_DETAILS]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [SHIPMENT_DETAILS_CONSTANTS.LANE_ORIGINATION]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [SHIPMENT_DETAILS_CONSTANTS.BILL_OF_LADING_ORIGINATION_CITY]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [SHIPMENT_DETAILS_CONSTANTS.BILL_OF_LADING_ORIGINATION_COUNTRY]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [SHIPMENT_DETAILS_CONSTANTS.DESTINATION_DETAILS]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [SHIPMENT_DETAILS_CONSTANTS.LANE_DESTINATION]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [SHIPMENT_DETAILS_CONSTANTS.BILL_OF_LADING_DESTINATION_CITY]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [SHIPMENT_DETAILS_CONSTANTS.BILL_OF_LADING_DESTINATION_COUNTRY]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [SHIPMENT_DETAILS_CONSTANTS.CARGO_DESCRIPTION]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [SHIPMENT_DETAILS_CONSTANTS.SEAL_STATUS]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [SHIPMENT_DETAILS_CONSTANTS.INVOICE_DETAILS]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [SHIPMENT_DETAILS_CONSTANTS.INVOICE_NUMBER]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [SHIPMENT_DETAILS_CONSTANTS.INVOICE_CURRENCY_CODE]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [SHIPMENT_DETAILS_CONSTANTS.TOTAL_INVOICE_VALUE]: {
    value: "",
    errors: [],
    hidden: false,
  },
};
